import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "return-window",
    title: "Return window",
    body: [
      "A return request may be submitted within 30 days of the recorded delivery date. Items must be unworn, unwashed and unaltered, with all original tags attached and the proof of purchase available.",
      "Trying a garment on carefully is welcome. Please keep cosmetics, fragrance, pet hair and other marks away from it, as an item that cannot be offered again may not be accepted.",
    ],
  },
  {
    id: "return-exclusions",
    title: "Items that cannot be returned",
    items: [
      "Products clearly marked final sale, unless they arrive faulty or applicable consumer law provides otherwise.",
      "Gift cards, personalised or altered products, and items sold for hygiene-sensitive use where a protective seal has been removed.",
      "Garments showing wear, washing, damage, scent or missing tags that occurred after delivery.",
      "A purchase made through another retailer; it should be returned to the original place of purchase.",
    ],
  },
  {
    id: "start-return",
    title: "How to start a return",
    body: [
      "Contact customer care with the order reference, the item being returned and the reason for the request. Wait for return instructions before sending anything, because parcels sent to an unconfirmed address can be delayed or refused.",
      "Use a trackable service and keep the lodgement receipt until the return is complete. Return postage is paid by the customer unless the item is confirmed faulty, incorrect, or the published offer states otherwise.",
    ],
    links: [{ to: "/contact", label: "Start a return request" }],
  },
  {
    id: "refunds",
    title: "Assessment and refunds",
    body: [
      "Returns are normally assessed within five business days of arrival. Once approved, the item price is sent back to the original payment method. Original delivery charges are not normally refundable unless the complete order was faulty, incorrect, or required by applicable law.",
      "Banks and payment providers can take a further three to ten business days to show a refund. Any promotion applied to the order will be recalculated against the items kept, and the refund may be adjusted accordingly.",
    ],
  },
  {
    id: "exchanges",
    title: "Exchanges",
    body: [
      "Because sizes and washes can sell through quickly, we do not reserve direct exchanges. Return the original item and place a new order for the preferred size or style once the return has been accepted.",
    ],
  },
  {
    id: "faults",
    title: "Faulty or incorrect items",
    body: [
      "Report a manufacturing fault, incorrect item or transit damage promptly, with clear photographs and the order reference. Fair wear, accidental damage and failure to follow care instructions are not manufacturing faults.",
      "Nothing in this policy is intended to limit a remedy that cannot lawfully be excluded in the customer's destination.",
    ],
    links: [
      { to: "/shipping", label: "Review shipping information" },
      { to: "/terms", label: "Read the terms of use" },
    ],
  },
];

function Returns() {
  return (
    <PolicyLayout
      title="Returns & Refunds"
      intro="Our return process is designed to be straightforward while keeping every garment in excellent condition."
      updated="Effective September 2026"
      sections={sections}
      action={{ to: "/contact", label: "Start a return" }}
    />
  );
}

export default Returns;
